export const navLinks = [
  { name: 'Features', href: '#features' },
  { name: 'How it works', href: '#howitworks' },
  { name: 'Prices', href: '#pricing' },
];

export const features = [
  {
    id: 1,
    icon: 'Settings',
    title: 'Channel specific',
    subtitle: 'customization',
    description: 'Ability to customize chatbots for specific channels, such as Telegram and WhatsApp.',
  },
  {
    id: 2,
    icon: 'MessageSquare',
    title: 'Automated',
    subtitle: 'messaging',
    description: "Automate customer interactions with waatee's advanced features. Enhance experience and streamline chatbot management.",
  },
  {
    id: 3,
    icon: 'Search',
    title: 'User engagement',
    subtitle: 'tracking',
    description: 'Tools to track and respond to user interactions with the chatbot on Telegram and WhatsApp.',
  },
  {
    id: 4,
    icon: 'Radio',
    title: 'Broadcasting &',
    subtitle: 'group messaging',
    description: 'Ability to broadcast messages and manage group messaging for Telegram and WhatsApp.',
  },
];

export const stats = [
  { value: '3.5K', label: 'Active users' },
  { value: '250', label: 'Brands' },
  { value: '3.5K', label: 'Accounts Managed' },
  { value: '30K', label: 'Active leads' },
];

export const testimonial = {
  quote: "Waatee is a game-changer for our business! The user interface is user-friendly and the reporting features provide valuable insights. Integration with Telegram and WhatsApp has allowed us to reach our customers where they are most active. Highly recommend!",
  author: 'Sarah Johnson',
  role: 'Founder and CEO',
  company: 'Active',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200',
};

export const pricingPlans = [
  {
    id: 1,
    name: 'Free',
    description: 'Get started with a free plan that includes basic chatbot management features.',
    price: null,
    cta: 'Start for free',
    features: [
      'Chatbot management features at no cost.',
      'Start for free, with no obligation to upgrade',
    ],
    popular: false,
  },
  {
    id: 2,
    name: 'Pay as you go',
    description: 'Pay only for the features you use with a flexible Pay As You Go plan. Upgrade anytime!',
    price: null,
    cta: 'Upgrade now',
    features: [
      'Unlimited Chatbot',
      'Unlimited Connect Account',
      'Unlimited Webhook',
      'API Integration',
    ],
    popular: true,
  },
  {
    id: 3,
    name: 'Enterprise',
    description: 'Advanced features, dedicated support for large businesses. Looking for your own branding?',
    price: null,
    cta: 'Contact us',
    features: [
      'Custom Branding',
      'Custom Domain',
      'Custom User Role',
      'Custom Pricing Plan',
    ],
    popular: false,
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "Waatee has revolutionized the way we manage our chatbots. The user interface is intuitive and the reporting features are top-notch. Highly recommend!",
    author: 'Sarah Lee',
    company: 'Happy Customers Inc.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200',
  },
  {
    id: 2,
    quote: "As a small business owner, I was looking for a cost-effective chatbot management solution and waatee fit the bill perfectly. The free plan is great for getting started.",
    author: 'Emma Brown',
    company: 'Fresh Foods Inc',
    avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=200',
  },
  {
    id: 3,
    quote: "The advanced reporting features in waatee have provided valuable insights into our customer interactions. We're able to make data-driven decisions.",
    author: 'Logan Boy',
    company: 'BeMe',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200',
  },
  {
    id: 4,
    quote: "Waatee has made it easier for us to manage our chatbots and reach our customers on Telegram and WhatsApp. The real-time analytics have been a game-changer.",
    author: 'Laraine Summers',
    company: 'Hello W.',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200',
  },
  {
    id: 5,
    quote: "We've been using waatee for a few months now and it has made a huge impact on our business. The integration with Telegram and WhatsApp is seamless.",
    author: 'Michael Johnson',
    company: 'Bright Corp',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200',
  },
  {
    id: 6,
    quote: "I was hesitant to try a new chatbot management tool, but waatee exceeded my expectations. The user interface is user-friendly.",
    author: 'Rachel Green',
    company: 'Efficient Tech',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200',
  },
];

export const faqs = [
  {
    id: 1,
    question: 'What is waatee?',
    answer: 'Waatee is a chatbot management tool that helps businesses manage and enhance their chatbot capabilities. It offers advanced features such as real-time analytics, response management, and seamless integration with Telegram and WhatsApp.',
  },
  {
    id: 2,
    question: 'What makes waatee unique?',
    answer: 'Waatee offers a user-friendly interface, advanced reporting capabilities, and integration with Telegram and WhatsApp, making it a comprehensive solution for businesses looking to enhance their chatbot performance.',
  },
  {
    id: 3,
    question: 'What are the pricing options for waatee?',
    answer: 'Waatee offers a free plan, a Pay As You Go plan, and an Enterprise plan to fit the needs of businesses of all sizes.',
  },
  {
    id: 4,
    question: 'Does Waatee support other channels besides Telegram and WhatsApp?',
    answer: 'Currently, waatee only supports Telegram and WhatsApp.',
  },
  {
    id: 5,
    question: 'Is there a trial period for waatee?',
    answer: 'Yes, waatee offers a free plan for businesses to get started and test out the tool. The Pay As You Go and Enterprise plans also offer flexible pricing options for businesses of all sizes.',
  },
];

export const howItWorks = [
  {
    id: 1,
    step: '1',
    title: 'Sign up',
    description: 'Quick and easy sign up process to get started with waatee.',
  },
  {
    id: 2,
    step: '2',
    title: 'Link',
    description: 'Connect Telegram & WhatsApp to waatee. Streamline chatbot management.',
  },
  {
    id: 3,
    step: '3',
    title: 'Chat',
    description: 'Start revolutionizing customer interactions with advanced chatbot management capabilities and response management.',
  },
];
